"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.AddonsContextConsumer = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    defaults = {
  actions: {
    getAddonsCost: void 0,
    getCostForAddon: void 0,
    getAddonValue: void 0,
    getAddonLabel: void 0,
    getFormattedAddon: void 0,
    getCaptions: void 0,
    mergeAddon: void 0,
    getCurrencySymbol: void 0
  },
  constants: {
    ASPECT_RATIOS: void 0,
    DURATIONS: void 0,
    RUSH_EDIT: void 0,
    CAPTIONS: void 0,
    VIDEO_OUTPUT: void 0,
    CAPTION_SAMPLES: void 0,
    CHROMA_KEY: void 0
  }
},
    addonsContext = _react["default"].createContext(defaults),
    _default = addonsContext;

exports["default"] = _default;
var AddonsContextConsumer = addonsContext.Consumer;
exports.AddonsContextConsumer = AddonsContextConsumer;